import { Container } from "./styles";
import { DateTime } from "luxon";

export const TippyContent = ({ job }) => {
  if (!job) return null;

  const start = DateTime.fromJSDate(job.start).toFormat(
    "dd/MM/yyyy 'ás' HH:mm",
  );
  const end = DateTime.fromJSDate(job.end).toFormat("dd/MM/yyyy 'ás' HH:mm");
  const endDuration =
    job.type === "task"
      ? DateTime.fromJSDate(job.start)
          .plus({ hours: job.duration.number })
          .toFormat("dd/MM/yyyy 'ás' HH:mm")
      : null;
  const labelStatus = job.status;

  const status =
    labelStatus === "doing"
      ? "Em execução"
      : labelStatus === "pending"
        ? "Pendente"
        : labelStatus === "done"
          ? "Concluído"
          : labelStatus === "doneLate"
            ? "Concluído com atraso"
            : "Atrasado";

  return (
    <Container status={job.status}>
      <ul>
        <li>Nome: {job.label}</li>
        <li>
          Status: <span>{status}</span>
        </li>
        {job.accountable ? (
          <li>Responsável: {job.accountable.username} </li>
        ) : null}

        {job.status === "done" || job.status === "doneLate" ? (
          <>
            <li>Início: {start}</li>
            <li>Fim: {end}</li>
          </>
        ) : job.status === "doing" ? (
          <>
            <li>Início: {start}</li>
            <li>Prazo final: {end} </li>
          </>
        ) : job.status === "pending" ? (
          <>
            <li>Início (Previsto): {start}</li>
            <li>Prazo final (Previsto): {end} </li>
          </>
        ) : (
          <>
            <li>Início: {start}</li>
            <li>Expirado em: {endDuration} </li>
          </>
        )}
      </ul>
    </Container>
  );
};
